package com.iregained.site.theme

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color

object SiteBrandColors {
    const val Primary = 0x008080
    const val PrimaryHover = 0x006666
    const val PrimarySoft = 0xE5F2F2
    const val PrimarySoftDark = 0x123333
    const val SecondaryAccent = 0xF3DB5B
}

/**
 * @property nearBackground A useful color to apply to a container that should differentiate itself from the background
 *   but just a little.
 */
class SitePalette(
    val nearBackground: Color,
    val cobweb: Color,
    val brand: Brand,
    val custom: Custom // Added a custom section for your specific UI colors
) {
    class Brand(
        // --- 10% ACCENT COLORS ---
        // Reserved strictly for high-value interactions (CTAs, Links, Icons, Active Tabs)
        val primary: Color = Color.rgb(SiteBrandColors.Primary),
        val primaryHover: Color = Color.rgb(SiteBrandColors.PrimaryHover),
        val accent: Color = Color.rgb(SiteBrandColors.SecondaryAccent),

        // --- 30% SECONDARY COLORS ---
        // Used for alternating section backgrounds (e.g., Hero sections, Testimonials)
        val primarySoft: Color = Color.rgb(SiteBrandColors.PrimarySoft),
    )

    class Custom(
        // --- 30% SECONDARY COLORS (Typography) ---
        // Creates sharp readability without the harsh contrast of pure black
        val darkText: Color = Color.rgb(0x323232),

        // --- 60% DOMINANT COLORS ---
        // Used for the vast majority of the site's negative space and base backgrounds
        val lightGray: Color = Color.rgb(0xF8F9FA), // Clean, modern off-white
        val white: Color = Colors.White,

        // UI Utility
        val divider: Color = Color.rgb(0xE2E8F0) // Subtle, structural borders
    )
}

object SitePalettes {
    val light = SitePalette(
        nearBackground = Color.rgb(0xF4F6FA),
        cobweb = Colors.LightGray,
        brand = SitePalette.Brand(),
        custom = SitePalette.Custom()
    )
//    val dark = SitePalette(
//        nearBackground = Color.rgb(0x13171F), cobweb = Colors.LightGray.inverted(),
//        // If you ever do dark mode, you can easily define inverted colors here!
//        brand = SitePalette.Brand(primarySoft = Color.rgb(SiteBrandColors.PrimarySoftDark)),
//        custom = SitePalette.Custom(
//            darkText = Colors.White, lightGray = Color.rgb(0x2A2A2A), divider = Color.rgb(0x3A3A3A)
//        )
//    )
}

fun ColorMode.toSitePalette(): SitePalette {
//    return when (this) {
//        ColorMode.DARK -> SitePalettes.dark
//    }
    return SitePalettes.light
}

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    // TELL KOBWEB TO NEVER LISTEN TO THE OS DARK MODE PREFERENCE
    ctx.config.initialColorMode = ColorMode.LIGHT

    // Set the 60% and 30% global defaults at the absolute root level
    ctx.theme.palettes.light.background = Colors.White
    ctx.theme.palettes.light.color = Color.rgb(0x323232)

    ctx.theme.palettes.dark.background = Color.rgb(0x06080B)
    ctx.theme.palettes.dark.color = Colors.White
}
